import type { DispatchPrintTab, DispatchReprintRecord } from '@/types/invoice';

export interface DispatchReprintsState {
  byTabId: Record<string, DispatchReprintRecord[]>;
}

export interface DispatchReprintsActions {
  addRecord: (organizationId: string, tabId: string, printData: DispatchPrintTab) => void;
  getForTab: (tabId: string) => DispatchReprintRecord[];
  replaceForTab: (tabId: string, records: DispatchReprintRecord[]) => void;
  clearForTab: (tabId: string) => void;
}

export type DispatchReprintsStore = DispatchReprintsState & DispatchReprintsActions;

export const DISPATCH_REPRINTS_INITIAL_STATE: DispatchReprintsState = {
  byTabId: {},
};
